import { render, staticRenderFns } from "./CreateReport.vue?vue&type=template&id=68617ae8&scoped=true"
import script from "./CreateReport.vue?vue&type=script&lang=js"
export * from "./CreateReport.vue?vue&type=script&lang=js"
import style0 from "./CreateReport.vue?vue&type=style&index=0&id=68617ae8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68617ae8",
  null
  
)

export default component.exports